// Segmenter matches the user-perceived characters counted by iOS and Android.
// The fallback preserves common emoji and combining sequences in older browsers.
const splitNoteCharacters = (text) => {
    if (typeof Intl.Segmenter === 'function') {
        return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), part => part.segment);
    }
    const characters = [];
    let regionalCount = 0;
    for (const point of Array.from(text)) {
        const previous = characters[characters.length - 1];
        const regional = /\p{Regional_Indicator}/u.test(point);
        const continuation = /[\p{Mark}\p{Emoji_Modifier}\uFE0E\uFE0F\u200D\u{E0020}-\u{E007F}]/u.test(point);
        if (previous && (continuation || previous.endsWith('\u200D') ||
            (regional && regionalCount % 2 === 1) || (previous === '\r' && point === '\n'))) {
            characters[characters.length - 1] += point;
        } else {
            characters.push(point);
        }
        regionalCount = regional ? regionalCount + 1 : 0;
    }
    return characters;
};

export const countNoteCharacters = text => splitNoteCharacters(text).length;

export const limitNoteText = (text, maxCharacters = 200) => (
    splitNoteCharacters(text).slice(0, Math.max(0, maxCharacters)).join('')
);

export const isEmojiOnlyNote = text => {
    const characters = splitNoteCharacters(text.trim());
    return characters.length > 0 && characters.length <= 3 && characters.every(character => (
        /^[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\uFE0E\uFE0F\u200D\u20E3\u{E0020}-\u{E007F}0-9#*]+$/u.test(character) &&
        /[\p{Extended_Pictographic}\p{Regional_Indicator}\u20E3]/u.test(character)
    ));
};
